import { render, staticRenderFns } from "./catProductos.vue?vue&type=template&id=7b309098&scoped=true"
import script from "./catProductos.vue?vue&type=script&lang=js"
export * from "./catProductos.vue?vue&type=script&lang=js"
import style0 from "./catProductos.vue?vue&type=style&index=0&id=7b309098&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b309098",
  null
  
)

export default component.exports